import * as React from 'react';

import {useGetBeeToken} from '../../email-marketing/bee-editor/graphql/hooks/use-get-bee-token';

import {BeeEditor} from './bee-editor';

type Props = {
    onChange: (beeContentJson: string) => any;
    beeBodyJson: string | null | undefined;
};

export function BeeEditorLandingPages(props: Props) {
    const {beeToken} = useGetBeeToken('page_builder');

    if (!beeToken) return null;

    return <BeeEditor beeToken={beeToken} {...props} />;
}
